import tournaments from '@/services/_api/tournaments'
import promocodes from '@/services/_api/promocodes'
import deposit from '@/services/_api/billing/deposit'
import withdrawal from '@/services/_api/billing/withdrawal'
import commission from '@/services/_api/billing/commission'
import apple_pay from '@/services/_api/billing/apple_pay'
import cashboxHistory from '@/services/_api/billing/cashbox_history'
import userCards from '@/services/_api/billing/user_cards'
import userPromotions from '@/services/_api/user_promotions'
import notifications from '@/services/_api/notifications'
import jackpot from '~/services/_api/jackpot'
import levels from '@/services/_api/levels'
import raffle from '@/services/_api/raffle'
import customChance from '@/services/_api/custom-chance'
import wof from '@/services/_api/wof'
import chance from '@/services/_api/chance'
import bm from '@/services/_api/bm'
import userMessages from '@/services/_api/user_messages'
import userLimits from '@/services/_api/user-limits'
import billboard from '@/services/_api/billboard'
import seo from '@/services/_api/seo'
import service_status from '~/services/_api/service_status'
import diia from '~/services/_api/diia'
import bankid from '~/services/_api/bankid'
import kycaid from '~/services/_api/kycaid'
import auth from '~/services/_api/auth'
import profile from '~/services/_api/profile/index'
import users from '~/services/_api/users'
import user_documents from '~/services/_api/user_documents'
import lootboxes from '@/services/_api/lootboxes'
import tickets from '@/services/_api/tickets'
import games from '@/services/_api/games'
import v2games from '@/services/_api/v2-games'
import base from '@/services/_api/base'
import guestUser from '@/services/_api/guest-user'

import { useGetters } from '~/services/_api/helpers/getters'

export default ({ $config, $axios, store, app }, inject) => {
  const config = useGetters({ i18n: app.i18n, device: app.$device })

  const api = {
    tournaments: tournaments($axios),
    promocodes: promocodes($axios),
    deposit: deposit($axios, { apiPaymentUrl: $config.apiPaymentUrl }),
    withdrawal: withdrawal($axios, { apiPaymentUrl: $config.apiPaymentUrl }),
    commission: commission($axios, { apiPaymentUrl: $config.apiPaymentUrl }),
    apple_pay: apple_pay($axios, { apiPaymentUrl: $config.apiPaymentUrl }),
    cashboxHistory: cashboxHistory($axios, { apiPaymentUrl: $config.apiPaymentUrl }),
    userCards: userCards($axios, { apiPaymentUrl: $config.apiPaymentUrl }),
    userPromotions: userPromotions($axios),
    jackpot: jackpot($axios, { apiUrl: $config.apiUrlV4, $formFactor: config.$formFactor }),
    notifications: notifications($axios, { apiUrl: $config.apiUrlV4 }),
    levels: levels($axios),
    raffle: raffle($axios),
    billboard: billboard($axios),
    seo: seo($axios, { apiUrl: $config.apiUrlV4, apiUrlV2: $config.apiUrl }),
    service_status: service_status($axios),
    diia: diia($axios, config),
    bankid: bankid($axios),
    kycaid: kycaid($axios),
    auth: auth($axios, config),
    profile: profile($axios),
    users: users($axios),
    user_documents: user_documents($axios),
    userMessages: userMessages($axios),
    userLimits: userLimits($axios),
    customChance: customChance($axios),
    wof: wof($axios),
    chance: chance($axios),
    bm: bm($axios),
    lootboxes: lootboxes($axios),
    tickets: tickets($axios),
    _games: games($axios, { apiUrl: $config.apiUrlV4, ...config }),
    games: v2games($axios, config),
    base: base($axios, { apiUrl: $config.apiUrlV4 }),
    guestUser: guestUser($axios),
  }

  if (app.prototype) {
    app.prototype.$api = api
  }
  inject('api', api)
  return api
}
